import React from 'react';
import { Spin } from 'antd';
import {WeaErrorPage, WeaLocaleProvider, WeaTools} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import { isEqual, isEmpty } from 'lodash';
import AddWfCom from './AddWf';
import {setContentviewHeight} from "../../util/common";
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
                refresh: false,
            }); 
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        const tabdata_local = ls.getJSONObj('tabdata-' + params.eid + '-' + tabid);
        this.setState({
            refresh: tabid === currentTab,
            currentTab: tabid,
            tabdata: tabdata_local == null ? {} : tabdata_local,
        });
        WeaTools.callApi('/api/portal/element/addwftab', 'POST', {...params, tabid}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
       });
    }
    render() {
        let contentHtml = <div width="100%"></div>;
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state; 
        const { tabids, titles, esetting } = edata;
        let { fontStyle,header } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        esetting.fontStyle = fontStyle;
        const { eid } = config.params;
        const { contentview = {} } = config.item;
        let cstyle = {};
        if(header.displayPosition && header.displayPosition == 'bottom' && tabids && tabids.length > 1){
            if(contentview.style.height){
                if(esetting.tabstyle == '1' && esetting.tabvalue){
                    cstyle = setContentviewHeight(contentview.style.height,esetting.tabvalue)
                }else{
                    cstyle = {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"};
                }   
            }else {
                cstyle = {height: contentview.style.height,overflow: "auto"};
            }
        }else if(tabids && tabids.length == 1){
            cstyle = {height: contentview.style.height,overflow: "auto"};
        }
        if(header.displayPosition && header.displayPosition == 'bottom') {
            if (tabids && tabids.length > 1 || tabids && tabids.length == 1 && esetting.isAlwaysShow == '1') {
                let elementH=parseInt(contentview.style.height)-parseInt($(`#titleContainer_${eid}`).css('height'))-33;
                if(elementH!=parseInt(cstyle.height)){
                    if(elementH<parseInt(cstyle.height)){
                        cstyle.height=elementH+"px";
                    }
                }
            }
        }
        if (!isEmpty(tabdata)) {
            contentHtml = <AddWfCom ecId={`${this && this.props && this.props.ecId || ''}_AddWfCom@cjp7eo`} eid={eid} data={tabdata} esetting={esetting} contentview={contentview} cstyle={cstyle}/>
        }
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            tabstyle: esetting.tabstyle,
            tabvalue: esetting.tabvalue,
            handleTabData: this.handleTabData
        }
        return <div>
                <Title ecId={`${this && this.props && this.props.ecId || ''}_Title@f4gjz0`} {..._titleProps}/>
                <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height,'overflow-y':'auto'}}>
                    <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@clnwhy`} spinning={refresh}>{contentHtml}</Spin>
                </div>
            </div>;
    }
}



class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@1pl11k`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/addwf/EContent.js